export default "__VITE_ASSET__4a21797a__"